import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { staticSite } from "../config";

function Layout({ children }) {
  const { pathname } = useLocation();
  const isBackOffice = !staticSite && (pathname.startsWith("/admin") || pathname.startsWith("/rider"));
  return (
    <>
      {!isBackOffice && <Navbar />}
      <main>{children}</main>
      {!isBackOffice && <Footer />}
    </>
  );
}

export default Layout;
